"use client";

import { Message } from "@/lib/core/crm/types";
import { useMessageActionHandlers } from "./hooks/useMessageActionHandlers";
import { MessageDesktopActions } from "./MessageDesktopActions";
import { MessageMobileActions } from "./MessageMobileActions";
import { ComposeModalContainer } from "../compose/ComposeModalContainer";
import { SaveAttachmentsToGoogleDriveModalContainer } from "./SaveAttachmentsToGoogleDriveModalContainer";
import { useGlobalModalStack, MODAL_IDS } from "@wtc/ui";

interface MessageActionsProps {
  message: Message;
  onCopyLink?: () => void;
  className?: string;
}

export function MessageActions({ message, onCopyLink, className }: MessageActionsProps) {
  const handlers = useMessageActionHandlers(message);
  const { openModal } = useGlobalModalStack();

  // Use handlers directly - handleReply from useMessageActionHandlers already passes the correct data
  const mergedHandlers = handlers;

  const handleSaveAttachmentsClick = () => {
    openModal(MODAL_IDS.messages.saveAttachmentsToGoogleDrive, { message });
  };

  return (
    <>
      {/* Desktop Actions - Gmail-like (Trash + Three dots) */}
      <MessageDesktopActions
        message={message}
        handlers={mergedHandlers}
        onCopyLink={onCopyLink}
        onSaveAttachmentsToGoogleDrive={handleSaveAttachmentsClick}
        className={className}
      />

      {/* Mobile Actions - Gmail-like (Reply/Forward 50/50) + More Menu */}
      <MessageMobileActions
        message={message}
        handlers={mergedHandlers}
        onCopyLink={onCopyLink}
        className={className}
      />

      {/* Dialogs and Modals */}
      <handlers.ArchiveDialog />
      <handlers.DeleteDialog />
      <handlers.SpamDialog />

      {/* Compose Modal - now delegated entirely to global modal stack */}
      <ComposeModalContainer />

      {/* Save Attachments to Google Drive Modal - now delegated to global modal stack */}
      <SaveAttachmentsToGoogleDriveModalContainer />
    </>
  );
}
